import { useNavigate } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { AuthLayout } from '../components/AuthLayout'
import { FormButton } from '../components/FormButton'
import { usePermission } from '../../hooks/usePermission'

interface TenantMismatchPageProps {
  userEmail: string
  tenantName: string
  correctSlug: string
}

export function TenantMismatchPage({
  userEmail,
  tenantName,
  correctSlug,
}: TenantMismatchPageProps) {
  const navigate = useNavigate()
  const { can } = usePermission()

  const homePath = can('view_dashboard')
    ? `/${correctSlug}/dashboard`
    : can('search_products')
      ? `/${correctSlug}/engineer`
      : `/${correctSlug}/no-access`

  const buttonLabel = 'Go to my account'

  return (
    <AuthLayout
      title="Access denied"
      subtitle="You don't have access to this organisation."
    >
      <div className="flex flex-col items-center gap-6 py-4">
        <ShieldAlert size={48} className="text-amber-500" />
        <div className="text-center">
          <p className="text-sm text-gray-700">
            You're signed in as <strong>{userEmail}</strong>
          </p>
          <p className="text-sm text-gray-500 mt-1">
            Organisation: <strong>{tenantName}</strong>
          </p>
        </div>
        <FormButton
          onClick={() => navigate(homePath)}
          fullWidth
        >
          {buttonLabel}
        </FormButton>
        <FormButton
          onClick={() => navigate('/auth/logout')}
          variant="secondary"
          fullWidth
        >
          Sign out
        </FormButton>
      </div>
    </AuthLayout>
  )
}
